import React from "react";
import { Box, Flex, Text, VStack, Heading } from "@chakra-ui/react";
import { motion } from "framer-motion";

const timelineData = [
  {
    year: "2022",
    title:
      "Journey begins with a clear vision: to make solar engineering easy, efficient, and uncompromising in quality, serving in the US and Canada",
  },
  {
    year: "2023",
    title:
      "Expanded our reach to India, successfully engineering 250 MW of solar projects and growing our global footprint",
  },
  {
    year: "2024",
    title:
      "Further extended our services into East Asia, completing engineering for 500 MW and delivering scalable, reliable solar solutions across regions",
  },
  {
    year: "2025",
    title:
      "Today, we’re proud to have surpassed 1,000 MW of engineered capacity — powering a greener future worldwide with confidence and innovation",
  },
];

const MotionBox = motion(Box);

export default function Timeline() {
  return (
    <Box
      px={{ base: 4, md: 20 }}
      py={10}
      bg="#c2e9d1ff"
      position="relative"
      overflow="hidden"
    >
      <MotionBox
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <Heading
          textAlign="center"
          mb={12}
          color="#519C36"
          fontWeight="bold"
          fontSize={{ base: "2xl", md: "3xl" }}
          letterSpacing="0.13em"
        >
          Our Journey
        </Heading>
        <Flex
          direction={{ base: "column", md: "row" }}
          align="flex-start"
          justify="space-between"
          gap={{ base: 10, md: 0 }}
          position="relative"
        >
          {/* Connecting line */}
          <Box
            position="absolute"
            top={{ base: "0", md: "48%" }}
            left={{ base: "50%", md: "4%" }}
            transform={{
              base: "translateX(-50%)",
              md: "translateY(-50%)",
            }}
            width={{ base: "2px", md: "92%" }}
            height={{ base: "100%", md: "5px" }}
            bg="#519C36"
            opacity={0.28}
            borderRadius="xl"
            zIndex={0}
          />
          {timelineData.map((item, idx) => (
            <MotionBox
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.58, delay: 0.13 * idx }}
              as={VStack}
              spacing={3}
              textAlign="center"
              w={{ base: "100%", md: "23%" }}
              align="center"
              bg="white"
              borderRadius="xl"
              boxShadow="0 4px 32px #305D2433"
              p={{ base: 5, md: 7 }}
              position="relative"
              zIndex={1}
              _hover={{
                boxShadow: "0 8px 40px #FBBF2444",
                transform: "scale(1.03)",
              }}
            >
              <Box
                w="18px"
                h="18px"
                bg="#FBBF24"
                borderRadius="full"
                boxShadow="0 2px 12px #FBBF2477, 0 0 30px #305D2433"
                border="3px solid #F5FAF6"
              />
              <Text
                fontWeight="bold"
                color="#305D24"
                fontSize="lg"
                letterSpacing="0.11em"
              >
                {item.year}
              </Text>
              <Text
                fontWeight="semibold"
                color="#519C36"
                fontSize="md"
                letterSpacing="0.045em"
              >
                {item.title}
              </Text>
            </MotionBox>
          ))}
        </Flex>
      </MotionBox>
    </Box>
  );
}
